import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/registration/store/action.type";

export const updateButtonStateAction = createAction(
  ActionType.UPDATE_BUTTON_PROCESS,
  props<{stateButton: boolean}>()
)
